import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Typography, mediaQuery } from '@lacedltd/laced-components'

export const Paragraph = styled(Typography.Text)({
  marginBottom: tokens.spacing[7],
  [mediaQuery.m.min]: { marginBottom: tokens.spacing[8] }
})

export const ButtonLink = styled.a({ marginBottom: tokens.spacing[7] })
